import React from 'react';
import ButtonIcon from '../ButtonIcon';
import { IconColors, IconSizes, IconVariants } from '../../constants';
const svgIcon = (<svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
    <g transform="scale(0.7) translate(2.5 2)">
      <path d="M1.99992 9.99982H-9.15527e-05V11.9998H1.99992V9.99982Z" fill="#EB5757"/>
      <path d="M5.33317 6.66653H3.33316V11.9999H5.33317V6.66653Z" fill="#EB5757"/>
      <path d="M8.6667 3.33322H6.66669V11.9999H8.6667V3.33322Z" fill="white" fillOpacity="0.2"/>
      <path d="M12 -4.57764e-05H10V12H12V-4.57764e-05Z" fill="white" fillOpacity="0.2"/>
    </g>
  </svg>);
const ButtonNPI = ({ size = IconSizes.Medium, variant = IconVariants.Plain, disabled = false, clickHandle = () => null, }) => {
    return (<ButtonIcon size={size} variant={variant} color={IconColors.Primary} disabled={disabled} clickHandle={clickHandle}>
      {svgIcon}
    </ButtonIcon>);
};
export default ButtonNPI;
